import { createPopper } from "@popperjs/core";
import { watch, ref } from "vue";

export const withTooltipProps = () => ({
    position: {
        type: String,
        default: "right",
        validator: (val) => {
            return [
                "auto",
                "auto-start",
                "auto-end",
                "top",
                "top-start",
                "top-end",
                "bottom",
                "bottom-start",
                "bottom-end",
                "right",
                "right-start",
                "right-end",
                "left",
                "left-start",
                "left-end",
            ].includes(val);
        },
    },
    activator: {
        type: null,
        required: true,
    },
    showTooltip: {
        type: Boolean,
        default: false,
    },
    showTitle: {
        type: Boolean,
        default: true,
    },
    showValidator: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: "form.password.tooltips.title",
    },
    titleClass: {
        type: String,
        default: "text-h4 font-semibold",
    },
    wrapperClass: {
        type: String,
        default: "max-w-xs",
    },
    icon: {
        type: Object,
        default: () => {},
    },
    iconClasses: {
        type: String,
        default: "w-5 h-5",
    },
});

export const useTooltipSetup = (props) => {
    const tooltipRef = ref(null);

    watch(
        () => props.showTooltip,
        (value) => {
            if (value) {
                createPopper(props.activator.$el, tooltipRef.value.$el, {
                    placement: props.position,
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 18],
                            },
                        },
                    ],
                });
            }
        }
    );

    return { tooltipRef };
};
